import { useState } from "react";
import UpdateLanguage from "../modal/UpdateLanguage";
import { Link } from "react-router-dom";
import { Popconfirm } from "antd";
import useRemoveAPI from "../../../utils/CustomHooks/useRemoveAPI";

export default function ListItem({ item, refresh, access = {} }) {
  const [isEdit, setEdit] = useState(false);
  const { removeLanguage } = useRemoveAPI();
  const onDelete = () => {
    removeLanguage({ language_id: item.language_id }, refresh);
  };

  return (
    <tr>
      <td className="col-sm-2">{item.language_name??"-"}</td>
      <td>
          {item.language_iso_short_code??"-"}
      </td>
      <td>
        <span
          className={`${item.active ? "good" : "bad"} text-center btn btn-sm`}
        >
          {item.active ? "Active" : "Disabled"}
        </span>
      </td>
      {access.canEdit && (
        <td>
        <button
          type="button"
          className="btn btn-outline-success btn-sm "
          onClick={() => setEdit(true)}
        >
          Edit
        </button>
      </td>
      )}
      <td>
      <Popconfirm
           title="Are you sure to delete this Language?"
           onConfirm={onDelete}
          //  onCancel={cancel}
           okText="Yes"
           cancelText="No"
          >
        <i
        className="ml-2 fas fa-trash cursor-pointer"
        // onClick={onDelete}
      ></i>
      </Popconfirm>
      </td>
      <UpdateLanguage
        isOpen={isEdit}
        setOpen={() => setEdit(false)}
        initialValue={item}
        refresh={refresh}
      />
    </tr>
  );
}
